import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 30,
  medium: 22,
  small: 16,
  xSmall: 10
};
const ArrowUpIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  const renderIcon = () => {
    switch (size) {
      case "large":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 40 40",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M34.2662 29L35 28.3455L20 11L5 28.3643L5.76447 28.9812L20 12.5537L34.2662 29Z",
              fill: "currentColor"
            }
          )
        );
      case "medium":
      default:
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 30 30",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M25.2474 22L26 21.3415L15 9L4 21.3604L4.78404 21.9811L15 10.4528L25.2474 22Z",
              fill: "currentColor"
            }
          )
        );
      case "small":
      case "xSmall":
        return /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            width: iconWidth,
            height: iconHeight,
            viewBox: "0 0 20 20",
            preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
            fill: "none",
            ...others
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
              fill: "white"
            }
          ),
          /* @__PURE__ */ React.createElement(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M17.135 14.533L17.8645 13.849L9.99978 5.45996L2.13501 13.849L2.86455 14.533L9.99978 6.92202L17.135 14.533Z",
              fill: "currentColor"
            }
          )
        );
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, renderIcon());
};
ArrowUpIcon.iconName = "ArrowUpIcon";

export { ArrowUpIcon };
